export function handleUnauthorized(response) {
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem('token');
    window.location.href = '/login'; // Adjust to your login route
    return true;
  }
  return false;
}